/*
 * サブシステム名：受注
 * 機能名：受付一覧
 */
import DdCustomButton from '@/components/DdCustomButton'
import DdCheckbox from '@/components/DdCheckbox'
import DdCodeTextBox from '@/components/DdCodeTextBox.vue'
import DdDataTable from '@/components/DdDataTable'
import DdDateBox from '@/components/DdDateBox'
import DdDateRangeBox from '@/components/DdDateRangeBox'
import DdDropDown from '@/components/DdDropDown'
import DdFooterButton from '@/components/DdFooterButton'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdSubHeader from '@/components/DdSubHeader'
import DdSwitch from '@/components/DdSwitch'
import DdTextBox from '@/components/DdTextBox'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'
import modals from '@/ddv2.library/modals'
import validators from '@/rahmen/validators'
// import date from '@/ddv2.library/date'

// 個別メッセージ用
import Swal from 'sweetalert2'

const DdSelectItemsPerPage = () => import('@/components/DdSelectItemsPerPage')

export default {
  name: 'ankenList',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    selected: [],
    conditions: {},
    searchText: '',
    modeKengen: 0,
    page: 1,
    isLoading: false,
    filterConfirmationRequiredFlg: false,

    // ヘッダー定義
    headersJininList: header.mstJininHeaders,
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    headersHinmeiList: header.mstHinmeiHeaders,

    // PrintLoading
    isExcelDownloader: false,
    isBatchCommandloader: false,
    isCheckSheetDownloader: false,

    // ページネーション用
    vItemsPerPage: 100,
    vPage: 1,

    // 一括操作用定義
    batchCommand: null,
    batchCommandList: [
      { value: null, text: '未選択' },
      { value: '90', text: 'ステータス更新' },
      { value: '01', text: 'チェックリストDL' },
      { value: '04', text: '領収書DL' },
      { value: '02', text: 'フロント写真DL' },
      { value: '03', text: '写真DL' },
      { value: '11', text: '取付作業前写真DL' },
      { value: '12', text: '取付作業中写真DL' },
      { value: '13', text: '取付作業後写真DL' },
      { value: '21', text: '取外作業前写真DL' },
      { value: '22', text: '取外作業中写真DL' },
      { value: '23', text: '取外作業後写真DL' }
    ],
    isShowUpdateStatusDialog: false,
    batchStatus: {
      sagyoKanryoFlg: false,
      uriageKakuteiFlg: false,
      notYayoiRenkeiFlg: false
    }
  }),
  components: {
    DdCustomButton,
    DdCodeTextBox,
    DdCheckbox,
    DdDataTable,
    DdDateBox,
    DdDateRangeBox,
    DdDropDown,
    DdFooterButton,
    DdIconButtonWithTooltip,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdSubHeader,
    DdSwitch,
    DdTextBox,
    DdSelectItemsPerPage
  },
  watch: {
    'conditions.zenjitsuSagyoKanryoFlg': function () {
      if (this.conditions.zenjitsuSagyoKanryoFlg) {
        var date = new Date()
        const zenjitsu = filter.dateFormatter(new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1))
        this.conditions.sagyoStartYmdString = zenjitsu
        this.conditions.sagyoEndYmdString = zenjitsu
      }
    },
    'conditions.iraisakiId': function () {
      if (!this.isLoading) this.conditions.sagyoTantoshaId = null
    }
  },
  computed: {
    ...mapGetters({
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      jininList: 'DDMasters/mstJinin',
      hinmeiList: 'DDMasters/mstHinmei',
      kubunList: 'DDMasters/msysKubun',
      shubetsuList: 'DDMasters/mstShubetsu',
      loginUserId: 'users/userId',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    filteredRows () {
      console.log('filter', this.rows)
      const self = this
      return this.rows.map((elem) => {
        // 表示用作業依頼日作成
        var sagyoIraiYmdFromDisp = elem.sagyoIraiYmdFrom ? (filter.dateFormatter(elem.sagyoIraiYmdFrom)).slice(-8) : ''
        var sagyoIraiYmdToDisp = elem.sagyoIraiYmdTo ? '～' + (filter.dateFormatter(elem.sagyoIraiYmdTo)).slice(-5) : ''
        var sagyoIraiYmdFromTo = sagyoIraiYmdFromDisp + sagyoIraiYmdToDisp

        // 表示フォーマット編集
        const elem2 = { ...elem }
        elem2.sagyoIraiYmdFrom = elem.sagyoIraiYmdFrom ? (filter.dateFormatter(elem.sagyoYoteiYmdFrom)) : ''
        elem2.sagyoIraiYmdTo = elem.sagyoIraiYmdTo ? (filter.dateFormatter(elem.sagyoYoteiYmdTo)) : ''
        elem2.sagyoIraiYmdFromTo = sagyoIraiYmdFromTo
        elem2.jissekiSagyoYmdDisp = elem.jissekiSagyoYmd ? (filter.dateFormatter(elem.jissekiSagyoYmd)).slice(-8) : ''
        elem2.dispSeikyuKingaku = [undefined, null, ''].includes(elem.seikyuKingaku) ? '' : filter.numericFormatter(elem.seikyuKingaku) + '円'
        elem2.dispShiharaiKingaku = [undefined, null, ''].includes(elem.shiharaiKingaku) ? '' : filter.numericFormatter(elem.shiharaiKingaku) + '円'

        // 状況表示
        // 0:未着手,1:完了待ち,2:キャンセル,8:キャンセル完了,9:完了
        elem2.sagyoKanryoStatus = elem.sagyoKanryoFlg && elem.sagyoCancelFlg ? '8' : elem.sagyoKanryoFlg && !elem.sagyoCancelFlg ? '9' : !elem.sagyoKanryoFlg && elem.sagyoCancelFlg ? '2' : !elem.sagyoKanryoFlg && ![undefined, null, 0].includes(elem.checksheetCount) ? '1' : '0'
        // 0:未確定,9:確定
        elem2.uriageKakuteiStatus = elem2.uriageKakuteiFlg ? '9' : '0'

        elem2.checksheetStatus = [undefined, null, 0].includes(elem.checksheetCount) ? '無' : '有'
        elem2.receiptStatus = [undefined, null, 0].includes(elem.receiptCount) ? '無' : '有'

        // 案件番号
        elem2.dispAnkenNo = elem2.chumonNo

        return elem2
      }).filter((elem) => {
        return !self.filterConfirmationRequiredFlg || (self.filterConfirmationRequiredFlg && elem.sagyoKanryoStatus === '1')
      })
    },
    // 得意先
    filteredTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        return elem.tokuisakiFlg === true && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    // 発注先
    filteredHacchusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        return (elem.hacchusakiFlg === true || elem.torihikisakiBunruiKbn1 === '02') && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    // 受付担当者
    filteredUketsukeTantoshaList () {
      const target = filter.dateFormatter(new Date())
      return this.jininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        const jisha = this.torihikisakiList.filter(elem2 => elem2.torihikisakiBunruiKbn1 === '02')
        if (!jisha) {
          return false
        }
        return jisha.some(elem2 => elem2.torihikisakiCd === elem.shanaiBiko3) && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.jininCd > elem2.jininCd) { return 1 }
        if (elem1.jininCd === elem2.jininCd) { return 0 }
        return -1
      })
    },
    // 作業担当者
    filteredSagyoTantoshaList () {
      const target = filter.dateFormatter(new Date())
      return this.jininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        const sagyoIraisaki = this.filteredHacchusakiList.find(elem2 => elem2.id === this.conditions.iraisakiId)
        if (!sagyoIraisaki) {
          return false
        }
        return elem.shanaiBiko3 === sagyoIraisaki.torihikisakiCd && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.jininCd > elem2.jininCd) { return 1 }
        if (elem1.jininCd === elem2.jininCd) { return 0 }
        return -1
      })
    },
    // 商品名
    filteredShohinList () {
      const target = filter.dateFormatter(new Date())
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        return elem.hinshuSbt === '01' && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.hinmeiCd > elem2.hinmeiCd) { return 1 }
        if (elem1.hinmeiCd === elem2.hinmeiCd) { return 0 }
        return -1
      })
    },
    // 作業区分
    filteredSagyoKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'TGK001')
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    isBatchExecButtonDisabled () {
      if (this.modeKengen === 0) {
        return true
      }
      if (this.batchCommand !== null && this.selected.length > 0) {
        return false
      }
      return true
    },
    isCreateButtonDisp () {
      return this.modeKengen >= 1
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'mstjinin', 'msthinmei', 'msyskubun', 'mstshubetsu'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('TGRCOD0010.defineHeaderPromise')
            self.headers = [
              { text: '', value: 'data-table-select', align: 'center', width: '42px' },
              { text: '編集', value: 'actions', sortable: false, width: '42px', align: 'center' },
              { text: '案件No', value: 'dispAnkenNo', width: '150px' },
              { text: '車番', value: 'newShabanPlateNo', width: '150px' },
              { text: 'ドア番', value: 'doorNo', width: '100px' },
              { text: '作業状況', value: 'sagyoKanryoStatus', width: '105px', align: 'center', sortable: false },
              { text: '売上状況', value: 'uriageKakuteiStatus', width: '105px', align: 'center', sortable: false },
              { text: '作業予定日', value: 'sagyoIraiYmdFromTo', width: '105px' },
              { text: '得意先', value: 'tokuisakiNm' },
              { text: '受付担当者', value: 'tantoshaNm' },
              { text: '取付先', value: 'toritsukesaki' },
              { text: '営業所', value: 'toritsukesakiEigyosho' },
              { text: 'ジャンル', value: 'jenreNm' },
              { text: '作業', value: 'sagyoKbnNm' },
              { text: '商品', value: 'shohinNm' },
              { text: '作業依頼先', value: 'sagyoIraisakiNm' },
              { text: '作業実施者', value: 'sagyoTantoshaNm' },
              { text: '作業完了日', value: 'jissekiSagyoYmdDisp', width: '80px' },
              { text: '請求金額', value: 'dispSeikyuKingaku', align: 'right', width: '105px' },
              { text: '支払金額', value: 'dispShiharaiKingaku', align: 'right', width: '105px' },
              { text: 'チェックシート', value: 'checksheetStatus', align: 'center', width: '120px' },
              { text: '領収書', value: 'receiptStatus', align: 'center', width: '120px' },
              { text: '自社管理番号', value: 'jishaDenpyoNo' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              tantoshaId: self.loginUserId,
              sagyoIraiYmdFrom: null,
              sagyoIraiYmdTo: null,
              jissekiSagyoYmdFrom: null,
              jissekiSagyoYmdTo: null,
              tokuisakiId: null,
              toritsukesaki: null,
              toritsukesakiEigyosho: null,
              chumonNo: null,
              sagyoKbn: null,
              shohinId: null,
              newShabanPlateNo: null,
              sagyoIraisakiId: null,
              sagyoTantoshaId: null,
              sagyoJunbiFlg: true,
              sagyoKanryoMachiFlg: true,
              sagyoKanryoFlg: true,
              seikyuKakuteiFlg: true
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('TGRCOD0010.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          // DB上は"true"の文字列で設定される。Booleanにするために文字列"true"と比較させる。
          self.conditions.includeCancelFlg = ![undefined, null].includes(c.includeCancelFlg) ? c.includeCancelFlg === 'true' : false
          self.conditions.excludeSeikyuTomeFlg = ![undefined, null].includes(c.excludeSeikyuTomeFlg) ? c.excludeSeikyuTomeFlg === 'true' : false
          self.conditions.excludeYayoiRenkeiFlg = ![undefined, null].includes(c.excludeYayoiRenkeiFlg) ? c.excludeYayoiRenkeiFlg === 'true' : false

          console.log('TGRCOD0010.savedInputRestorePromise', self.conditions)
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('TGRCOD0010.researchPromise', c)
          // modals.showToast('検索中です。しばらくお待ちください。', 1500, 550, 'top-end', 'info')
          return new Promise(resolve => {
            if (c.cache.value) {
              self.isLoading = true
              self.conditions = c.cache.value.conditions || {}
              self.searchText = c.cache.value.searchText || ''
              self.$nextTick(() => { self.isLoading = false })
            }
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('TGRCOD0010.restoreViewPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.isLoading = true
              self.conditions = c.cache.value.conditions || {}
              self.searchText = c.cache.value.searchText || ''
              self.rows = c.cache.value.rows || []
              self.$nextTick(() => { self.isLoading = false })
            }
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.selected = []
      this.vPage = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          self.isLoading = true

          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/vwCTgrcod001180/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
              self.isLoading = false
            })
        },
        getSavedInputMethod: function () {
          return {
            includeCancelFlg: self.conditions.includeCancelFlg,
            excludeSeikyuTomeFlg: self.conditions.excludeSeikyuTomeFlg,
            excludeYayoiRenkeiFlg: self.conditions.excludeYayoiRenkeiFlg
          }
        }
      }
      this.search(opt)
    },
    searchValidate: function () {
      console.log('searchValidate')
      // 受付日FROM TOの大小チェック
      var msg = validators.compareDate(this.conditions.juchuStartYmdString, this.conditions.juchuEndYmdString)
      if (msg !== undefined) {
        this.$refs.juchuStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.juchuEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.setInvalidSummaryMessage('COME0014')
        return false
      }
      // 依頼日FROM TOの大小チェック
      msg = validators.compareDate(this.conditions.iraiStartYmdString, this.conditions.iraiEndYmdString)
      if (msg !== undefined) {
        this.$refs.iraiStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.iraiEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.setInvalidSummaryMessage('COME0014')
        return false
      }
      // 作業予定日FROM TOの大小チェック
      msg = validators.compareDate(this.conditions.sagyoYoteiStartYmdString, this.conditions.sagyoYoteiEndYmdString)
      if (msg !== undefined) {
        this.$refs.sagyoYoteiStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.sagyoYoteiEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.setInvalidSummaryMessage('COME0014')
        return false
      }
      // 作業日FROM TOの大小チェック
      msg = validators.compareDate(this.conditions.sagyoStartYmdString, this.conditions.sagyoEndYmdString)
      if (msg !== undefined) {
        this.$refs.sagyoStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.sagyoEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.setInvalidSummaryMessage('COME0014')
        return false
      }
      return true
    },
    clear: function () {
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            // const d = new Date()
            self.conditions = {
              tantoshaId: self.loginUserId,
              sagyoIraiYmdFrom: null,
              sagyoIraiYmdTo: null,
              jissekiSagyoYmdFrom: null,
              jissekiSagyoYmdTo: null,
              tokuisakiId: null,
              toritsukesaki: null,
              toritsukesakiEigyosho: null,
              chumonNo: null,
              sagyoKbn: null,
              shohinId: null,
              newShabanPlateNo: null,
              sagyoIraisakiId: null,
              sagyoTantoshaId: null,
              sagyoJunbiFlg: true,
              sagyoKanryoMachiFlg: true,
              sagyoKanryoFlg: true,
              seikyuKakuteiFlg: true
            }
            self.searchText = ''
            self.rows = []
            self.selected = []
            self.vPage = 1
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    onRowDoubleClick: function (e, f) {
      console.log('onRowDoubleClick', e, f)
      this.saveConditionToCache()
      this.Effects.loadStart()
      this.transition(0, { id: f.item.trJuchuMeisaiId, backactionno: 3 })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      console.log('onRowEditButtonClick', item)
      this.saveConditionToCache()
      this.Effects.loadStart()
      this.transition(0, { id: item.trJuchuMeisaiId, backactionno: 3 })
    },
    saveConditionToCache: function () {
      const cache = {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
      this.saveToChache(cache)
    },

    onExcelDownloadButtonClick: function (e) {
      // ダウンロード対象作成
      var sagyoMeisaiIdList = []
      this.selected.forEach((x) => {
        sagyoMeisaiIdList.push(x.id)
      })
      const idList = {
        trSagyoMeisaiId: sagyoMeisaiIdList
      }

      if (idList.length === 0) return

      this.isExcelDownloader = true
      this.HttpClient
        .requestFileByPost('/api/v1/VwCTgrcod001180/ExcelOutput', idList)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const elem = document.getElementById('download')
          this.isExcelDownloader = false
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '作業一覧_' + ts + '.xlsx'
          elem.click()
        })
    },
    onCheckSheetDownloadButtonClick: function (e) {
      console.log('onCheckSheetDownloadButtonClick')
      const self = this

      // ダウンロード対象作成
      var sagyoMeisaiIdList = []
      this.selected.forEach((x) => {
        sagyoMeisaiIdList.push(x.id)
      })
      const idList = {
        trSagyoMeisaiId: sagyoMeisaiIdList
      }

      if (idList.length === 0) return

      this.isCheckSheetDownloader = false
      function specifiedDownloadPromise (idList) {
        return new Promise(function (resolve) {
          self.HttpClient
            .requestFileByPost('/api/v1/Tgprmd0100/CheckSheetSpecifiedDownload', idList)
            .then((data) => {
              const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
              const zipFileNmae = 'チェックシート' + '_' + ts + '.zip'
              const blob = new Blob([data], { type: 'application/zip' })
              const elem = document.getElementById('batchDownload')
              self.isCheckSheetDownloader = false
              elem.href = window.URL.createObjectURL(blob)
              elem.download = zipFileNmae
              elem.click()
              resolve(data)
            })
        })
      }
      specifiedDownloadPromise(idList).then(() => {
        self.Effects.loadComplete()
        modals.showSuccess('選択された車両のチェックシートをダウンロードしました')
      })
    },

    /**
     * ステータス一括更新
     */
    onCheckMatomeSeikyuFlg: function (e) {
      if (this.batchStatus.matomeSeikyuFlg) {
        this.batchStatus.uriageKakuteiFlg = true
        this.batchStatus.notYayoiRenkeiFlg = true
      }
    },
    onBatchCommandButtonClick: function (e) {
      if (this.batchCommand === null) return
      if (this.batchCommand === '90') {
        this.isShowUpdateStatusDialog = true
      } else if (this.batchCommand === '01') {
        this.isBatchCommandloader = true
        this.execCheckSheetSpecifiedDownLoad()
      } else if (this.batchCommand === '04') {
        this.isBatchCommandloader = true
        this.execReceiptSpecifiedDownLoad()
      } else {
        this.isBatchCommandloader = true
        this.execPictureSpecifiedDownLoad(this.batchCommand)
      }
    },
    execBatchUpdateStatus: function () {
      // modals.showToast('ステータス更新 > ' + this.selected.length, 1500, 550, 'top-end', 'info')
      const self = this

      this.Effects.loadStart()

      // 更新情報作成
      var sagyoMeisaiIdList = []
      this.selected.filter((x) => {
        sagyoMeisaiIdList.push(x.id)
      })
      const updInfo = {
        sagyoKanryoFlg: this.batchStatus.sagyoKanryoFlg,
        uriageKakuteiFlg: this.batchStatus.uriageKakuteiFlg,
        notYayoiRenkeiFlg: this.batchStatus.notYayoiRenkeiFlg,
        matomeSeikyuFlg: this.batchStatus.matomeSeikyuFlg,
        trSagyoMeisaiId: sagyoMeisaiIdList
      }

      function batchUpdatePromise (updInfo) {
        return new Promise(function (resolve) {
          self.HttpClient.post('/api/v1/Tgrcod0021/BatchStatusUpdate', updInfo).then((data) => {
            resolve(data)
          })
        })
      }
      batchUpdatePromise(updInfo).then(() => {
        self.Effects.loadComplete()
        modals.showSuccess('対象のステータスを更新しました。')
        self.isShowUpdateStatusDialog = false
        // 再検索
        this.onSearchButtonClick()
      })
    },
    execCheckSheetSpecifiedDownLoad: function () {
      const self = this

      this.Effects.loadStart()

      // ダウンロード対象作成
      var sagyoMeisaiIdList = []
      this.selected.filter((x) => {
        sagyoMeisaiIdList.push(x.id)
      })
      const updInfo = {
        trSagyoMeisaiId: sagyoMeisaiIdList
      }

      if (updInfo.length === 0) return

      function specifiedDownloadPromise (updInfo) {
        return new Promise(function (resolve) {
          self.HttpClient
            .requestFileByPost('/api/v1/Tgrcod0021/CheckSheetSpecifiedDownloadBySagyoMeisaiId', updInfo)
            .then((data) => {
              const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
              const zipFileNmae = 'チェックシート' + '_' + ts + '.zip'
              const blob = new Blob([data], { type: 'application/zip' })
              const elem = document.getElementById('batchDownload')
              self.isBatchCommandloader = false
              elem.href = window.URL.createObjectURL(blob)
              elem.download = zipFileNmae
              elem.click()
              resolve(data)
            })
        })
      }
      specifiedDownloadPromise(updInfo).then(() => {
        self.Effects.loadComplete()
        modals.showSuccess('選択された案件のチェックシートをダウンロードしました')
      })
    },
    execReceiptSpecifiedDownLoad: function () {
      const self = this

      this.Effects.loadStart()

      // ダウンロード対象作成
      var sagyoMeisaiIdList = []
      this.selected.filter((x) => {
        return x.receiptCount > 0
      }).forEach((x) => {
        sagyoMeisaiIdList.push(x.id)
      })
      const updInfo = {
        trSagyoMeisaiId: sagyoMeisaiIdList
      }

      if (updInfo.length === 0) return

      function specifiedDownloadPromise (updInfo) {
        return new Promise(function (resolve) {
          self.HttpClient
            .requestFileByPost('/api/v1/Tgrcod0021/ReceiptSpecifiedDownloadBySagyoMeisaiId', updInfo)
            .then((data) => {
              const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
              const zipFileNmae = '領収書' + '_' + ts + '.zip'
              const blob = new Blob([data], { type: 'application/zip' })
              const elem = document.getElementById('batchDownload')
              self.isBatchCommandloader = false
              elem.href = window.URL.createObjectURL(blob)
              elem.download = zipFileNmae
              elem.click()
              resolve(data)
            })
        })
      }
      specifiedDownloadPromise(updInfo).then(() => {
        self.Effects.loadComplete()
        modals.showSuccess('選択された案件の領収書をダウンロードしました')
      })
    },
    execPictureSpecifiedDownLoad: function (pictureSbt) {
      const self = this

      this.Effects.loadStart()

      // ダウンロード対象作成
      var sagyoMeisaiIdList = []
      this.selected.filter((x) => {
        sagyoMeisaiIdList.push(x.id)
      })
      const updInfo = {
        trSagyoMeisaiId: sagyoMeisaiIdList,
        pictureSbt: pictureSbt
      }

      if (updInfo.length === 0) return

      var pictureSbtNm = '写真'
      if (pictureSbt === '02') {
        pictureSbtNm = 'フロント写真'
      } else if (pictureSbt === '03') {
        pictureSbtNm = '写真'
      } else if (pictureSbt === '11') {
        pictureSbtNm = '取付前写真'
      } else if (pictureSbt === '12') {
        pictureSbtNm = '取付中写真'
      } else if (pictureSbt === '13') {
        pictureSbtNm = '取付後写真'
      } else if (pictureSbt === '21') {
        pictureSbtNm = '取外前写真'
      } else if (pictureSbt === '22') {
        pictureSbtNm = '取外中写真'
      } else if (pictureSbt === '23') {
        pictureSbtNm = '取外後写真'
      }

      function specifiedDownloadPromise (updInfo) {
        return new Promise(function (resolve) {
          self.HttpClient
            .requestFileByPost('/api/v1/Tgrcod0021/PictureSpecifiedDownloadBySagyoMeisaiId', updInfo)
            .then((data) => {
              const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
              const zipFileNmae = pictureSbtNm + '_' + ts + '.zip'
              const blob = new Blob([data], { type: 'application/zip' })
              const elem = document.getElementById('batchDownload')
              self.isBatchCommandloader = false
              elem.href = window.URL.createObjectURL(blob)
              elem.download = zipFileNmae
              elem.click()
              resolve(data)
            })
        })
      }
      specifiedDownloadPromise(updInfo).then(() => {
        self.Effects.loadComplete()
        modals.showSuccess('選択された案件の' + pictureSbtNm + 'をダウンロードしました')
      })
    },

    // v-data-table ダブルクリック不可クラス
    usableDblClick (item) {
      return 'usable-dblclick'
    },
    // EXCEL出力メッセージ
    showConfirmExcelOutputPattern: function (args) {
      return new Promise((resolve) => {
        Swal.fire({
          showDenyButton: true,
          showCancelButton: true,
          title: '',
          html: '行がチェックされています。<br>EXCEL出力対象を指定して下さい。',
          icon: 'question',
          confirmButtonColor: '#FFFFFF',
          confirmButtonText: 'チェックした行だけ出力',
          denyButtonColor: '#2F75B5',
          denyButtonText: '全て出力',
          cancelButtonColor: '#6E7D88',
          cancelButtonText: 'キャンセル',
          customClass: {
            actions: 'my-actions',
            cancelButton: 'order-1 sa-s-button-cancel right-gap',
            confirmButton: 'order-2 excel-output-confirm',
            denyButton: 'order-3 sa-s-button-deny'
          }
        }).then((result) => {
          resolve(result)
        })
      })
    },
    // ページ操作
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      if (this.filteredRows.length === 0) return
      this.vItemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.vItemsPerPage, this.vPage)
      })
    },
    changePage: function (e) {
      this.vPage = e
      if (this.filteredRows.length === 0) return
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.vItemsPerPage, this.vPage)
      })
    }
  }
}
